import { render } from "./ProjectsSection.vue?vue&type=template&id=d8d58438&scoped=true"
import script from "./ProjectsSection.vue?vue&type=script&lang=js"
export * from "./ProjectsSection.vue?vue&type=script&lang=js"

import "./ProjectsSection.vue?vue&type=style&index=0&id=d8d58438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d58438"]])

export default __exports__